import {useMutation, useQueryClient} from 'react-query';
import PostSeedAdvertisement from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IPostSeedAdvertisementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostSeedAdvertisement = ({onSuccess}: IPostSeedAdvertisementProps) => {
  const queryClient = useQueryClient();

  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: ISeedAdvertisementPayload) => {
      return PostSeedAdvertisement(payload);
    },

    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data); // Passing the response to onSuccess
      }

      queryClient.invalidateQueries({queryKey: ['my-ads']}); // Invalidate personal ads
      queryClient.invalidateQueries({queryKey: ['get-store-lab-views']}); // Invalidate store ads
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostSeedAdvertisement};
